module.exports = __webpack_public_path__ + "img/head1.aa69c115.png";